import React, { useState, ReactNode } from 'react';
import STEMONLogo from '../../img/logo.png';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';

const Logo = styled.img`width:200px;padding: 3px;margin-top:3px;`
const HanberMenu = styled.div`
// パソコンは非表示　スマホは表示
display: none;
@media ${device.mobile}{
    display: block;
    position: fixed;
    right: 20px;
 }
`;
const MainScope = styled.div`
// パソコンは非表示　スマホは表示
position: fixed;
right: 0px;
left: 0px;
z-index: 1030;
top:0px;
}
@media ${device.mobile}{
  right: 0px;
 }
`;

const HanberBtn = styled.button`
    color: darkorange;
    padding: 10px;
`;
const ListMenuPc = styled.div`
// パソコンは表示　スマホは非表示
display: block;
@media ${device.mobile}{
    display: none;
 }
`;
const UlNone = styled.ul`
// パソコンは表示　スマホは非表示
display: none;
@media ${device.mobile}{
    display: block;
}
`;
// const ListMenuSp = styled.div`
// // パソコンは表示　スマホは非表示
// @media ${device.laptop}{
//     color: darkorange;
//  }
// `;
// 型宣言
interface FaqButtonProps {
  question: string;
  children: ReactNode;
}


const Navber = () => {
  const url ='/STEMON/';
  const [open, setContentState] = useState(false);
  return (
    <MainScope className='bg-orange-50'>
      <header className="container mx-auto font-bold text-black ">
        <div className="flex justify-between items-center">
        <Link to={url} ><Logo src={STEMONLogo} alt="ステモン高知　ロゴ"/></Link>
          {/* <h1 className="text-4xl font-semibold md:text-xl">HR</h1> */}
          {/* ハンバーガーメニュー */}
          <HanberMenu >
            <HanberBtn onClick={() => setContentState(!open)} >
              <span className={open ? 'block' : 'hidden' }><svg className="h-8 w-8 text-orange-500"  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg></span>
              <span className={open ? 'hidden' : 'block' }><svg className="h-6 w-6 fill-current" viewBox="0 0 24 24"><path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"/></svg></span>
              
            </HanberBtn>
          </HanberMenu>
        </div>
        <ListMenuPc>
            <ul className="md:flex md:justify-around">
              <Link to={url + 'Lesson'} onClick={() => setContentState(!open)} className="border-b md:border-none"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">授業内容</a></Link>
              <Link to={url + 'Course'} onClick={() => setContentState(!open)} className="border-b md:border-none"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">コース/料金</a></Link>
              <Link to={url + 'Join'} onClick={() => setContentState(!open)} className="border-b md:border-none"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">入会の流れ</a></Link>
              <Link to={url + 'Contact'} onClick={() => setContentState(!open)} className="border-b md:border-none"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">お問い合わせ</a></Link>
              <Link to={url + 'Blog'} onClick={() => setContentState(!open)} className="border-b md:border-none"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">ブログ</a></Link>
            </ul>
        </ListMenuPc>
        <div className={open ? 'block' : 'hidden' }>
            <UlNone className="md:flex md:justify-around">
            <Link to={url + 'Lesson'} onClick={() => setContentState(!open)} className="border-b md:border-none text-center"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">授業内容</a></Link>
            <Link to={url + 'Course'} onClick={() => setContentState(!open)} className="border-b md:border-none text-center"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">コース/料金</a></Link>
            <Link to={url + 'Join'} onClick={() => setContentState(!open)} className="border-b md:border-none text-center"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">入会の流れ</a></Link>
            <Link to={url + 'Contact'} onClick={() => setContentState(!open)} className="border-b md:border-none text-center"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">お問い合わせ</a></Link>
            <Link to={url + 'Blog'} onClick={() => setContentState(!open)} className="border-b md:border-none text-center"><a className="block px-8 py-2 my-4 hover:bg-orange-600 hover:text-white rounded">ブログ</a></Link>
            </UlNone>
        </div>
      </header>
    </MainScope>
  );
}
export default Navber;